/* eslint-disable max-len */
/**
 * privacy-policy页面配置
 */
export default {
  title: 'Privacy Policy',
  content: `
  
  <p><b>Updated Date: April 14, 2020</b></p>
  <p>We at Think Academy International Education, Inc. (collectively with any subsidiaries or affiliates "We", "Us, or "Think Academy") have created this Privacy Policy to describe our policies and practices regarding the collection, use, and disclosure of information about You in connection with Your use of Our services, including those offered through Our websites ("<b>Websites</b>"), our online programs, mobile APPs and information collected in person. (collectively, the "<b>Services</b>").</p>
  <p>The terms "You" and "Your" refer exclusively to You, as a user of the Services.</p>
  <p>By using the Services, You agree to the collection and use of information as described in this policy. We reserve the right to change Our Privacy Policy from time to time by posting the changes here. We will notify You of any changes by posting the new Privacy Policy on this page. If We make any changes to this Privacy Policy that significantly affect Your rights, We will let You know via email or a prominent notice on the Website or through Our Services, and update the "effective date" at the top of this Privacy Policy. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when posted on this page. Your use of Our Services after We have made changes to Our Privacy Policy will mean that You have accepted those changes.</p>
  <p><b>BY USING THE SERVICES, YOU AGREE TO BE BOUND BY THE TERMS OF THIS PRIVACY POLICY. IF YOU DO NOT AGREE WITH THESE TERMS, PLEASE DO NOT USE THE SERVICES.</b></p>
  <p>If You have questions about anything in Our Privacy Policy, please contact us at:</p>
  <p>
    E-mail: <a href="mailto:privacy@thethinkacademy.com">privacy@thethinkacademy.com</a><br>
    or<br>
    Tel: 844-844-6587
  </p>
  
  <p><b>1.Children, Students and COPPA</b></p>

  <p>We provide tutoring and other educational programs to children under the age of 13 ("<b>Children</b>," "<b>Child</b>," or "<b>Student</b>"). We comply with the Children's Online Privacy Protection Act ("<b>COPPA</b>"). Following COPPA requirements, we inform you of our practices with regards to our collection, use, or disclosure of personal information from children under the age of 13, and to obtain verifiable parental consent prior to collecting, using, or disclosing any such information.</p>
  <p>If we discover we have collected information from a Child in a manner inconsistent with COPPA’s requirements, we will either seek the parent’s consent for that collection or delete the information. We will not require a Child to disclose more information than is reasonably necessary to utilize our Services.</p>
  <p><b>Verifiable Parental Consent</b>: In order for a Child to access our Services, a parent or legal guardian ("<b>Parent</b>") must provide verifiable parental consent. We will obtain verifiable consent from parents when they create a ThinkHub account. A verification code will be send to the phone number parents used to sign up for the ThinkHub. By purchasing and paying for the Service to be provided through ThinkHub, parents provided verifiable consent to the personal information we collect from Students as noticed in this policy.</p>
  <p>Generally, we obtain verifiable parental consent prior to collecting, using, or disclosing any personal information from Children. There are limited instances where we may collect information without parental consent in compliance with COPPA, including:</p>

  <ul>
    <li>To protect the security or integrity of the Website, applications and other technology;</li>
    <li>To take precautions against liability;</li>
    <li>To respond to judicial process and for law enforcement purpose;</li>
    <li>We may collect contact information to respond to a specific request from a Student on a one-time basis;</li>
    <li>When a Student register and create an account with us via the Website, a username may be selected by the Child; however, this username is only used for signing in and cannot be used to contact the child unless and until we receive verifiable parental consent; and</li>
    <li>To provide notice and obtain Parents’ permission.</li>
  </ul>
  <ul>
    <li><b>We do not track Students’ online activity for marketing and promotional purpose.</b></li>
    <li><b>Disclosure of information provided by Students.</b><br>We might disclose the information collected from Students to our affiliates and subsidiaries to improve our service and upgrade our products. We may also disclose the information to government authorities for compliance and law enforcement purposes. We may share the information with a third party as a result of merger, acquisition, consolidation, and reorganization. We may provide such information to our professional advisors such as accountants, auditors, lawyers, bankers, insurers or other professionals in the course of their provision of services to us.</li>
    <li><b>You have the right to access, modify, and delete the personal information provided by your Child.</b></li>
    <li><b>Real-time Video and Audio Communication: </b>We use real-time video and audio communication in our interactive online learning system. A Student could participate in streaming courses, record videos and take photos while using our service. During the class, there might be interactive practices that require students to upload photos, video or audio recordings. Parents may instruct the student to opt-out of such interactive practices.</li>
    <li><b>Recorded class and playback.</b> Please note that for <b>student’s playback needs, we might record real-time video or audio communications during the Zoom online class.</b> Please disable your camera if you do not wish student’s image to be recorded during the class. By leaving the camera open, you authorize us to record the student’s image and to share the recorded class with the rest of the classmates.</li>
  </ul>

  <p><b>2.INFORMATION WE COLLECT, USE AND SHARE</b></p>
  <p><b>Personal Information</b></p>
  <p>We may ask You to provide us with certain personally identifiable information that can be used to contact or identify You ("<b>Personal Information</b>"). Personal Information may include, but is not limited to:</p>

  <ul>
    <li><b>Your Account Information:</b> You provide your email, cellphone number, or log in for a third-party account, to create an online or application account or subscribe to our communications. When creating Your account, You may be asked to enter certain information, such as your name, avatar, age, gender, address, telephone number, email address, username and password, nickname, and portrait (possibly obtained through third- party software), etc. If You refuse to provide part or all of these information, You may not be able to create an account on our Website or be able to use the Services. We will not ask Students for their own contact information without your prior consent.</li>
    <li><b>Student Data Provided by a Parent:</b> Parents provide information about their children to register them for our Service. We will not make a Student’s real name publicly available on our website.</li>
  </ul>

  <p><b>Customer Support:</b> When You contact Us, You can provide Us with information about You or Your Child’s use of the Services, including information about Our program you enroll and Your contact details, so that We can provide customer support.</p>
  <p><b>Information Regarding Usage of Our Service</b></p>
  <p>We may collect and handle Personal Information directly from Your use (or Students’ use) of Our Service ("<b>Service Usage Information</b>"). Service Usage Information may include, but is not limited to:</p>

  <ul>
    <li><b>Student Performance Data:</b> When Students use our Service, we may record and store their progress and performance ("<b>Student Performance Data</b>"). We use this data in order to provide our Service and to analyze and improve Our Service. The Parent linked to a Student’s account has access to reports on such Student Performance Data. Limited Student Performance Data may be publicly available through the app if the student chooses to participate in certain competitions and games, but Parents can adjust privacy settings via the Website or Service at any time to remove or limit the disclosure of Student Performance Data.</li>
    <li><b>Usage Information:</b> We may record information about the usage of the Service, including actions taken, date and time, frequency, duration, quantity, active time, and other feature usage information.</li>
    <li><b>User-Generated Information.</b> We retain the information uploaded, provided, or created by Parent and Student while using the Service. The Parent could use the student’s portal to view and manage any content created or uploaded by Student.</li>
  </ul>

  <p><b>Internet Usage Information</b></p>

  <p>We may collect information that Your browser sends whenever You use Our Services or when You access the Services by or through a mobile device ("<b>Internet Usage Information</b>").</p>
  <p>This Internet Usage Information may include information such as Your computer’s Internet Protocol address (e.g., IP address), browser type, browser version, the pages of Our Services that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
  <p>When You access the Services by or through a mobile device, this Internet Usage Information may include information such as the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.</p>

  <p><b>Information Collected from Third-Party Accounts</b></p>

  <p>We may collect and use information obtained from Facebook, Google, Amazon, WeChat and other accounts you use to interact with us ("<b>Third-Party Accounts</b>"), such as your name, your user name or handle, profile picture, your friend list and other details you may have on your Third-Party Account profile ("<b>Third-Party Information</b>"). We do not have access to your Third-Party Account passwords. The data We receive from Third-Party Accounts is dependent upon Your privacy settings with these third parties. You should always review, and if necessary, adjust Your privacy settings on Third-Party Accounts before linking or connecting them to Our website or Services. We use Third-Party Information to operate, maintain, and provide to You the features and functionality of the Services, to process and ship orders, to provide customer Services, and to communicate directly with You, such as to send You information about Your orders, product sales, special offers, and new site features.</p>
  <p>The information we collect is subject to this Privacy Policy. The information collected and stored by a third party remains subject to the third party's privacy practices, including whether the third party continues to share information with us, the types of information shared, and your choices with regard to what is visible to others on that third party web site and service. The third party may allow you to remove the application or feature, in which case we will no longer collect information about you through the application or feature, but we may retain the information previously collected in compliance with all applicable laws.</p>

  <p><b>Device and Automatically Collected Information</b></p>

  <ul>
    <li><b>Device Properties and Operations:</b> We collect certain information from and about Your smartphone, tablet, or personal computers ("<b>Device</b>"), such as Device number, model, hardware and software version, signal intensity, Internet Protocol (IP) addresses, and other information. We also collect information about the operations You perform on the Device, such as time, frequency, and duration of use.</li>
    <li><b>Device Signals:</b> We collect information that Your Device sends out or receives to tailor the Services to Our users in different regions, such as geo-location, IP addresses, and external hardware information from Your Device about surrounding Wi-Fi access points, beacons, and cell towers. You can enable and disable communicating such information to us by adjusting Your Device security and privacy settings.</li>
    <li><b>Analytics Information:</b> We may collect analytics data or use third-party analytics tools to help us measure traffic and usage trends for the Sites and to understand more about the demographics of Our users.</li>
    <li><b>Cookies and similar technologies:</b> Our Services utilize Cookies, Web Beacons and similar technologies to improve your current and future experience by allowing us to understand your usage of our Services. Cookies and similar technologies, such as pixels and web beacon, are small text files that are sent to or accessed from Your web browser or Your computer’s hard drive. A cookie typically contains the name of the domain (internet location) from which the cookie originated, the "lifetime" of the cookie (i.e., when it expires), and a randomly generated unique number or similar identifier. A cookie also may contain information about the Device, such as user settings, browsing history, and activities conducted while using Our Services. We use cookies and similar technologies to assist you in logging into the apps and platforms, to save your preference, personalize your user experience and to protect spam and abuse. Our Services use the following cookies:</li>
    <ul>
      <li>oStrictly necessary cookies, which are required for the operation of the Services. Without them, for example, you would not be able to use your account.</li>
      <li>oAnalytical/performance cookies, which allow Us to recognize and count the number of visitors, learn how visitors navigate the Services, and improve the Services.</li>
      <li>Functionality cookies, which We use to recognize You when you return to the Services.</li>
    </ul>
    <li class="list_style_none">You may manage the cookies on your device by disabling or deleting certain cookies. Please note that our Services may not work properly if you disable cookies. Please note, we do not respond to the Do Not Track Signals.</li>
  </ul>

  <p><b>3.USE OF INFORMATION</b></p>

  <p>We may use Your Personal Information for legitimate business purposes, including:</p>
  <p><b>To provide the functionality of Our Services and related support.</b></p>
  <ul>
    <li>To create, and administer accounts, fulfill and record transactions, fulfill and improve, analyze the performance of Students and our Services, and provide You and Students with related assistance (e.g., technical help, answer inquiries relating to Personal Information, etc.).</li>
    <li>To send administrative information to You, for example, information regarding Our Services and changes to Our terms, conditions, and policies.</li>
  </ul>
  <p>We will engage in these activities to manage Our contractual relationship with You, with Your consent, and to comply with Our legal obligations.</p>
  <p><b>To provide You with marketing and promotional materials and opportunities and facilitate social sharing.</b></p>
  <ul>
    <li>To send You marketing communications and offer other materials that We believe may be of interest to You, such as to send You newsletters or other direct communications.</li>
    <li>To share information with other marketers (and their Services providers) to permit them to send You marketing communications, consistent with Your choices.</li>
    <li>To facilitate social sharing functionality if You choose to do so.</li>
  </ul>
  <p>We will engage in this activity with Your consent, to manage Our contractual relationship with You, or where We have a legitimate interest. You may opt-out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email We send.</p>
  
  <p><b>For reporting and trending.</b></p>
  <ul>
    <li>To better understand You, the Students and Our other users, so that We can tune and personalize Our Services.</li>
    <li>For trending and statistics, and to improve Our Services.</li>
  </ul>

  <p>We will engage in this activity because We have a legitimate interest.</p>

  <p><b>To accomplish Our business purposes.</b></p>
  <ul>
    <li>For audits, to verify that Our internal processes function as intended and are compliant with legal, regulatory, or contractual requirements.</li>
    <li>For fraud and security monitoring purposes, for example, to detect and prevent cyberattacks or attempts to commit identity theft.</li>
    <li>For responding to legal duties, such as requests from public and government authorities.</li>
  </ul>

  <p>We will engage in these activities to comply with a legal obligation or because We have a legitimate interest.</p>
  <p>To the extent that We process Your Personal Information or Personal Information of Your Children based on Your consent, You may withdraw Your consent at any time. You may make the request to withdraw Your consent to the contacts provided below:</p>
  <p>E-mail: <a href="mailto:privacy@thethinkacademy.com">privacy@thethinkacademy.com</a><br>or<br>Tel: 844-844-6578</p>

  <p><b>4.DATA RETENTION</b></p>
  <p>We will retain Your Personal Information or Personal Information of Your Children only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Information or Personal Information of Your Children to the extent necessary to comply with Our legal obligations (for example, if We are required to retain Your information to comply with applicable laws), resolve disputes, and enforce Our legal agreements and policies.</p>
  <p>We will also retain Service Usage Information and Internet Usage Information for internal analysis purposes. Service Usage Information is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Services, or We are legally obligated to retain this data for longer time periods.</p>


  <p><b>5.DATA DISCLOSURE</b></p>
  <p>We will not disclose your information to a third party unless otherwise stated below:</p>
  <p><b>Consented Disclosure</b></p>
  <p>We may share your personal information with your consent to do so. Some services may allow you to share your personal data with other users. Please consider carefully before disclosing any personal information.</p>
  <p><b>Business Transaction</b></p>
  <p>If We are involved in a merger, acquisition, or asset sale, Your Personal Information and Personal Information of Your Children may be transferred. We will provide notice before such Personal Information is transferred and becomes subject to a different Privacy Policy.</p>
  <p><b>Disclosure for Law Enforcement</b></p>
  <p>Under certain circumstances, we may be required to disclose Your Personal Information or Personal Information of Your Children if required to do so by law or in response to valid requests by public authorities (e.g., a court or a government agency).</p>
  <p><b>Legal Requirements</b></p>
  <p>We may disclose Your Personal Information in the good faith belief that such action is necessary:</p>
  <ul>
    <li>To comply with a legal obligation</li>
    <li>To protect and defend the rights or property of Think Academy</li>
    <li>To prevent or investigate possible wrongdoing in connection with the Services</li>
    <li>To protect the personal safety of users of the Services or the public</li>
    <li>To protect against legal liability</li>
  </ul>
  <p><b>Affiliates and Authorized Third Party</b></p>
  <p>We may disclose your information to our affiliates and authorized third party for the purpose stated in this policy, including fulfilling our service such as customer service, delivery of your purchases, billings, managing and analyzing consumer data, conducting market research, and improving our service. These affiliates and authorized third parties will not use your personal information for any other purposes.</p>

  <p><b>6.DATA SECURITY</b></p>
  <p>The security of Your data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We use industry customary means designed to protect Your Personal Information, We cannot guarantee its absolute security. In the event that any information under Our control is compromised as a result of a breach of security, We will take reasonable steps to investigate the situation and where appropriate, notify those individuals whose information may have been compromised and take other steps, in accordance with any applicable laws and regulations.</p>

  <p><b>7.SERVICES PROVIDERS</b></p>
  <p>We may employ third party providers to provide the Services on Our behalf, to perform or support Services, or to assist us in analyzing how Our Services is used.</p>
  <p>These third parties have access to Your Personal Information only to perform these tasks on Our behalf and are obligated not to disclose or use it for any other purpose.</p>

  <ul>
    <li><b>Tracking and Online Advertising</b></li>
  </ul>
  <p>We may participate in interest-based advertising and use third-party advertising companies to serve You targeted advertisements based on Your online browsing history and Your interests. We permit third-party online advertising networks, social media companies and other third-party services, to collect information about Your use of Our website and online applications over time so that they may play or display ads on Our website, on other websites, apps or Services that You may use, and on other Devices You may use. Typically, though not always, the information used for interest- based advertising is collected through cookies or similar tracking technologies. We may share a common account identifier (such as an email address or user ID) or hashed data with Our third- party advertising partners to help identify you across Devices. We and Our third-party partners use this information to make the advertisements you see online more relevant to your interests, as well as to provide advertising-related Services such as reporting, attribution, analytics and market research.</p>

  <ul>
    <li><b>Shipping and Delivery</b></li>
  </ul>
  <p>We employ other companies and individuals to fulfill orders, deliver packages, and sending postal mails. These companies will have access to your personal information for a limited purpose to perform their functions but may not use it for other purposes.</p>

  <ul>
    <li><b>Payments</b></li>
  </ul>
  <p>We may provide paid products and/or services within Our Services. In that case, We use third-party for payment processing (e.g. payment processors).</p>
  <p>We will not store or collect Your payment card details. That information is provided directly to Our third-party payment processors whose use of Your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.</p>
  <p>The following is a list of current third-party vendors that may either directly or indirectly collect information from You. Please review the relevant privacy policies (links current as of the date of publication of this Privacy Policy) for further information on how each third-party handles Your Personal Information:</p>

  <table width="100%">
    <tr>
      <td width="40%"><b>Third-Party Name</b></td>
      <td width="60%"><b>Privacy Policy/Notice Link</b></td>
    </tr>
    <tr>
      <td><b>PayPal</b></td>
      <td>
        <div>
          <a href="https://www.paypal.com/va/webapps/mpp/ua/privacy-full">https://www.paypal.com/va/webapps/mpp/ua/privacy-full</a>
        </div>
      </td>
    </tr>
    <tr>
      <td><b>Avalara, Inc.</b></td>
      <td>
        <div>
          <a href="https://www.avalara.com/us/en/legal/privacy-policy.html">https://www.avalara.com/us/en/legal/privacy-policy.html</a>
        </div>
      </td>
    </tr>
    <tr>
      <td><b>USPS</b></td>
      <td>
        <div>
          <a href="https://about.usps.com/who-we-are/privacy-policy/welcome.htm">https://about.usps.com/who-we-are/privacy-policy/welcome.htm</a>
        </div>
      </td>
    </tr>
  </table>

  <p><b>8.Links to Other Websites</b></p>
  <p>This Privacy Policy does not address, and We are not responsible for, the privacy, information or other practices of any third parties. The inclusion of a link does not imply endorsement of the linked site or Services by Us.</p>
  <p>Please note that We are not responsible for the collection, usage and disclosure policies and practices (including the data security practices) of other organizations, such as Facebook, Apple, Google, Microsoft, RIM or any other application developer, application provider, social media platform provider, operating system provider, wireless Services provider or Device manufacturer, including any Personal Information You disclose to other organizations through or in connection with Our Services.</p>

  <p><b>9.YOUR PRIVACY RIGHTS UNDER THE CALIFORNIA CONSUMER PRIVACY ACT</b></p>
  <p>California residents are entitled to certain data protection rights under the California Consumer Privacy Act (CCPA). Think academy aims to take reasonable steps to allow you to correct, amend, delete or limit the use of your personal Information of California residents in operating our business, and their rights with respect to that personal information.</p>
  <p>As a Californian resident, you have the right:</p>

  <ul>
    <li>
      To request disclosure if Personal Information is collected, including
      <ul style="list-style-type:upper-alpha;">
        <li>the categories of Personal Informaiton collected, t</li>
        <li>the purpose for which the collected Personal Information would be used,</li>
        <li>the identity of third party with whom the Personal Information will be shared, and</li>
        <li>the business purpose for which the shared Personal Information would be used.</li>
      </ul>
    </li>
    <li>To access and receive a copy of the Personal Information We hold about You</li>
    <li>To rectify any Personal Information held about You that is inaccurate</li>
    <li>To request the deletion of Personal Information held about You</li>
    <li>To request disclosure if your Personal Information is sold</li>
    <li>To opt-out sell of your personal information</li>
  </ul>

  <p>Whenever made possible, You can update Your Personal Information or Personal Information of Your Children directly within Your or Student’s account settings section. If You are unable to change such Personal Information, please contact us to make the required changes.</p>
  <p>If You wish to be informed of what Personal Information We hold about You and if You want it to be removed from Our systems, please contact us.</p>

  <p>The chart below summarizes how we collect, use and share Personal Information by reference the categaries specified in the CCPA, and describes our practices during the 12 months preceding the effective date of this Privacy Policy.</p>

  <table>
    <tr>
      <td width="30%" class="font-bold">Category of Personal Information (PI)</td>
      <td width="70%" class="font-bold">Identifiers</td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">PI we collect</td>
      <td width="70%">
        your email, cellphone, or log in for a third- party account, your name, avatar, age, gender, address, telephone number, username and password, nickname, and portrait.
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Source of PI</td>
      <td width="70%">
        You or third party platform upon your approval
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Business/ commercial purpose for collection</td>
      <td width="70%">
        <ul>
          <li>Service delivery</li>
          <li>Research & development</li>
          <li>Marketing</li>
          <li>Compliance & Operations</li>
          <li>Aggregated or anonymous data for analytics</li>
          <li>Security, fraud protection, and safety</li>
          <li>Business transfers</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom the PI are disclosed</td>
      <td width="70%">
        <ul>
          <li>Affiliates.</li>
          <li>Business partners, whose service is required to deliver the service.</li>
          <li>Recorded online class containing parents or students’ images will be shared with classmates for playback purposes only.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom we "sell" PI</td>
      <td width="70%">
        None
      </td>
    </tr>
  </table>
  
  <table>
    <tr>
      <td width="30%" class="font-bold">Category of Personal Information (PI)</td>
      <td width="70%" class="font-bold">Commercial Information</td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">PI we collect</td>
      <td width="70%">
        Contact data；Identity data；Transaction data；Communications Marketing data
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Source of PI</td>
      <td width="70%">
        You
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Business/ commercial purpose for collection</td>
      <td width="70%">
        <ul>
          <li>Service delivery</li>
          <li>Research & development</li>
          <li>Marketing</li>
          <li>Compliance & Operations</li>
          <li>Aggregated or anonymous data for analytics</li>
          <li>Security, fraud protection, and safety</li>
          <li>Business transfers</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom the PI are disclosed</td>
      <td width="70%">
        <ul>
          <li>Professional advisors</li>
          <li>Authorities and others</li>
          <li>Business transferees</li>
          <li>Affiliates</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom we "sell" PI</td>
      <td width="70%">
        None
      </td>
    </tr>
  </table>

  <table>
    <tr>
      <td width="30%" class="font-bold">Category of Personal Information (PI)</td>
      <td width="70%" class="font-bold">Financial Information</td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">PI we collect</td>
      <td width="70%">
        Your credit card number, bank account number as well as any other information necessarily required to process a transaction.
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Source of PI</td>
      <td width="70%">
        You; Public sources; Business partners
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Business/ commercial purpose for collection</td>
      <td width="70%">
        <ul>
          <li>Service delivery</li>
          <li>Research & development</li>
          <li>Marketing</li>
          <li>Compliance & Operations</li>
          <li>Aggregated or anonymous data for analytics</li>
          <li>Security, fraud protection, and safety</li>
        </ul>
        <p>Business transfers</p>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom the PI are disclosed</td>
      <td width="70%">
        <ul>
          <li>Affiliates</li>
          <li>Advertising partners</li>
          <li>Professional advisors</li>
          <li>Authorities and others</li>
          <li>Business transferees</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom we "sell" PI</td>
      <td width="70%">
        None
      </td>
    </tr>
  </table>

  <table>
    <tr>
      <td width="30%" class="font-bold">Category of Personal Information (PI)</td>
      <td width="70%" class="font-bold">Online Identifiers</td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">PI we collect</td>
      <td width="70%">
        Device data; Identity data
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Source of PI</td>
      <td width="70%">
        Automatic collection
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Business/ commercial purpose for collection</td>
      <td width="70%">
        <ul>
          <li>Service delivery</li>
          <li>Research & development</li>
          <li>Marketing</li>
          <li>Compliance & Operations</li>
          <li>Aggregated or anonymous data for analytics</li>
          <li>Security, fraud protection, and safety</li>
          <li>Business transfers</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom the PI are disclosed</td>
      <td width="70%">
        <ul>
          <li>Affiliates</li>
          <li>Advertising partners</li>
          <li>Professional advisors</li>
          <li>Authorities and others</li>
          <li>Business transferees</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom we "sell" PI</td>
      <td width="70%">
        None
      </td>
    </tr>
  </table>

  <table>
    <tr>
      <td width="30%" class="font-bold">Category of Personal Information (PI)</td>
      <td width="70%" class="font-bold">Network and device information</td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">PI we collect</td>
      <td width="70%">
        Device data; Online activity data
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Source of PI</td>
      <td width="70%">
        Automatic collection
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Business/ commercial purpose for collection</td>
      <td width="70%">
        <ul>
          <li>Service delivery</li>
          <li>Research & development</li>
          <li>Marketing</li>
          <li>Compliance & Operations</li>
          <li>Aggregated or anonymous data for analytics</li>
          <li>Security, fraud protection, and safety</li>
          <li>Business transfers</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom the PI are disclosed</td>
      <td width="70%">
        <ul>
          <li>Affiliates</li>
          <li>Advertising partners</li>
          <li>Professional advisors</li>
          <li>Authorities and others</li>
          <li>Business transferees</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom we "sell" PI</td>
      <td width="70%">
        None
      </td>
    </tr>
  </table>

  <table>
    <tr>
      <td width="30%" class="font-bold">Category of Personal Information (PI)</td>
      <td width="70%" class="font-bold">Geolocation Data</td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">PI we collect</td>
      <td width="70%">
        Device data; 
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Source of PI</td>
      <td width="70%">
        Automatic collection
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Business/ commercial purpose for collection</td>
      <td width="70%">
        <ul>
          <li>Service delivery</li>
          <li>Research & development</li>
          <li>Marketing</li>
          <li>Compliance & Operations</li>
          <li>Aggregated or anonymous data for analytics</li>
          <li>Security, fraud protection, and safety</li>
          <li>Business transfers</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom the PI are disclosed</td>
      <td width="70%">
        <ul>
          <li>Affiliates</li>
          <li>Advertising partners</li>
          <li>Professional advisors</li>
          <li>Authorities and others</li>
          <li>Business transferees</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom we "sell" PI</td>
      <td width="70%">
        None
      </td>
    </tr>
  </table>

  <table>
    <tr>
      <td width="30%" class="font-bold">Category of Personal Information (PI)</td>
      <td width="70%" class="font-bold">Education Information</td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">PI we collect</td>
      <td width="70%">
        Performance; School information; Test result; Student profile
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Source of PI</td>
      <td width="70%">
        You
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Business/ commercial purpose for collection</td>
      <td width="70%">
        <ul>
          <li>Service delivery</li>
          <li>Research & development</li>
          <li>Compliance & Operations</li>
          <li>Aggregated or anonymous data for analytics</li>
          <li>Security, fraud protection, and safety</li>
          <li>Business transfers</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom the PI are disclosed</td>
      <td width="70%">
        <ul>
          <li>Affiliates</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom we "sell" PI</td>
      <td width="70%">
        None
      </td>
    </tr>
  </table>

  <table>
    <tr>
      <td width="30%" class="font-bold">Category of Personal Information (PI)</td>
      <td width="70%" class="font-bold">Inferences from the above information</td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">PI we collect</td>
      <td width="70%">
        Preference, trend or other information that could be assumed from above information
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Source of PI</td>
      <td width="70%">
        Automatic collection
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Business/ commercial purpose for collection</td>
      <td width="70%">
        <ul>
          <li>Service delivery</li>
          <li>Research & development</li>
          <li>Compliance & Operations</li>
          <li>Aggregated or anonymous data for analytics</li>
          <li>Security, fraud protection, and safety</li>
        </ul>
        <p>Business transfers</p>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom the PI are disclosed</td>
      <td width="70%">
        <ul>
          <li>Affiliates</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td width="30%" class="font-bold">Categories of third parties to whom we "sell" PI</td>
      <td width="70%">
        None
      </td>
    </tr>
  </table>

  <p>Although You cannot opt-out of all data collection when You use Our Services, You can limit the collection, use and sharing of Your personally identifiable information.</p>
  <p>You have the right to data portability. You can request to obtain a copy of Your Personal Information and Personal Information of Your Children in a commonly used electronic format so that You can manage and move it. Be advised that We may not be able to delete Your Personal Information or Personal Information of Your Children without also deleting Your or applicable Students’ user account. You will not be permitted to examine the Personal Information of any other person or entity and may be required to provide us with Personal Information to verify Your identity prior to accessing any records containing information about You. We may not accommodate a request to change or delete Personal Information if We believe doing so would violate any law or legal requirement or result in incorrect information.</p>
  <p>If You do not want us to collect Your Personal Information, please do not provide it to us. Please understand that if You choose not to provide certain Personal Information to us, Your choice will restrict Your ability to access some content and use some of the functionality of Our Services.</p>
  <p>For Your protection, We may only implement requests with respect to the Personal Information associated with the particular email address that You use to send us Your request, and We may need to verify Your identity before implementing Your request. We will try to comply with Your request as soon as reasonably practicable.</p>

  <p><b>10.CALIFORNIA SHINE THE LIGHT LAW</b></p>
  <p>California Civil Code Section 1798.83 permits users who are California residents to obtain from Us once a year, free of charge, a list of third parties to whom We have disclosed personal information (if any) for direct marketing purposes in the preceding calendar year. If You are a California resident and you wish to make such a request, please send an e-mail with "California Privacy Rights" in the subject line to <a href="mailto:privacy@thethinkacademy.com">privacy@thethinkacademy.com</a>.</p>


  <p><b>11.CHANGES TO OUR PRIVACY POLICY</b></p>
  <p>If We decide to change Our Privacy Policy, we will update the Privacy Policy modification date below.</p>

  <p>Last Modified: April 14, 2020.</p>

  <p><b>12.CONTACT US</b></p>
  <p>If You have any concerns relating to this Privacy Policy, You may correspond with Us by: </p>
  <p>Think Academy International Education, Inc.</p>
  <p>E-mail: <a href="mailto:privacy@thethinkacademy.com">privacy@thethinkacademy.com</a><br>or<br>Tel: 844-844-6578</p>

  `,
}
